import { createContext } from "react";

export interface DepositContentProps {
  price: number;
  currency: string;
  defaultRegion: string;
  email: string;
  name: string;
}

// Create a context
const DepositContext = createContext<DepositContentProps | undefined>(
  undefined
);

export default DepositContext;
